import { useEffect, useRef, useState } from "react";
import servicosColaborador from "../servicos/servicos-colaborador";
// import NavMenu from "./components/Nav";
import { Modal, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

import { useContext } from "react";
import AuthContext from '../servicos/autorizacao/AuthContex';
import servicosSolicitacaoExterna from "../servicos/servicos-solicitacao-externa";
import { toast, ToastContainer } from "react-toastify";
import NavMobile from "./components/NavMobile";
import { basePath } from "../utils/baseUrl";
import Delete from "../img/svgs/Delete";
import { CancelRounded, Check } from "@mui/icons-material";
import { Link } from "react-router-dom";
const moment = require('moment');


const Carrinho = () => {
    const { user, handleTermo } = useContext(AuthContext);
    const [carrinho, setCarrinho] = useState([]);
    const [flagAlteracaoCarrinho, setFlagAlteracaoCarrinho] = useState(false);
    const [total, setTotal] = useState(0);
    const [pontucaoExterna, setPontuacaoExterna] = useState([]);
    const [showConfirmacao, setShowConfirmacao] = useState(false);
    const motivo = useRef();
    const parceiro = useRef();
    const nomeParceiro = useRef();
    const [enderecoEnvio, setEnderecoEnvio] = useState(false);
    const logradouro = useRef(null);
    const numero = useRef(null);
    const bairro = useRef(null);
    const complemento = useRef(null);
    const cidade = useRef(null);
    const estado = useRef(null);
    const cep = useRef(null);

    const [aceiteTermo, setAceiteTermo] = useState(null);
    
    const navigate = useNavigate();
   
    useEffect(() => {
        const getDados = () => {
            servicosColaborador.getTotalPontosExternos(user.id)
                .then(response => {
                    if (response.status === 200) {
                        setPontuacaoExterna(response.data);
                    }
                }).catch(error => {
                    console.log(error);
                })
        }
        getDados();
    }, [user.id, user.termo]);

    useEffect(() => {
        const getDados = () => {
            servicosColaborador.listarUm(user.id)
                .then(response => {
                    if (response.status === 200) {
                        setAceiteTermo(response.data.termo);
                    }
                }).catch(error => {
                    console.log(error);
                })
        }
        getDados();
    }, [user.id, user.termo]);


    useEffect(() => {
        let carrinhoJSON = localStorage.getItem('carrinho_producao');

        let carrinho = JSON.parse(carrinhoJSON);

        setCarrinho(carrinho);
        let total = 0;
        if (carrinho?.produtos.length > 0) {
            for (const iterator of carrinho?.produtos) {
                let sub = Number(iterator.qtd) * Number(iterator?.produto?.Produto[0]?.milhas);
                total += sub;
            }

        }
        setTotal(total);

    }, [flagAlteracaoCarrinho]);

    const handleCloseConfirmacao = () => {
        setShowConfirmacao(false);
    }
    const handleCloseTermos = () => {
        setAceiteTermo(aceiteTermo);
    }


    const removerItem = (index) => {
        flagAlteracaoCarrinho === true ? setFlagAlteracaoCarrinho(false) : setFlagAlteracaoCarrinho(true);
        carrinho.produtos.splice(index, 1);
        localStorage.setItem('carrinho_producao', JSON.stringify(carrinho));
        setCarrinho(carrinho);
    };



    const atualizarQuantidade = (index, quantidade) => {
        const novoCarrinho = { ...carrinho };
        novoCarrinho.produtos[index].qtd = quantidade;
        setCarrinho(novoCarrinho);

        localStorage.setItem('carrinho_producao', JSON.stringify(novoCarrinho));
        let total = 0;
        for (const iterator of novoCarrinho.produtos) {
            let sub = Number(iterator.qtd) * Number(iterator.produto.Produto[0].milhas);
            total += sub;
        }
        setTotal(total);
    };


    const solicitarTroca = () => {

        if (motivo.current.value === "" || parceiro.current.value === "" || nomeParceiro.current.value === "") {
            toast.warning('Por favor informe o motivo da solicitação, nome e o código do parceiro beneficiado');
            return;
        } else {

            let tipoEnvio = 'Retirada Matriz';
            if (enderecoEnvio === true) {
                if (!logradouro.current.value || !numero.current.value || !bairro.current.value || !cidade.current.value || !estado.current.value || !cep.current.value) {
                    toast.warning('Por favor preencha o endereço completo!');
                    return
                } else {
                    tipoEnvio = logradouro.current.value + ', ' + numero.current.value + ' ' + complemento?.current?.value + '. ' + bairro.current.value + ', ' + cidade.current.value + ' ' + estado.current.value + ', ' + cep.current.value
                }
            }

            let objetoPedido = {
                "id_colaborador": user.id,
                "data_solicitacao": moment().format("YYYY-MM-DD"),
                "motivo_solicitacao": motivo.current.value,
                "cdg_parceiro": parceiro.current.value,
                "observacao": nomeParceiro.current.value + " " + String(tipoEnvio).toUpperCase()
            }

            let listaItems = [];
            for (const iterator of carrinho.produtos) {
                let item = {
                    "id_produto": iterator.produto.id_produto,
                    "quantidade": iterator.qtd,
                }
                listaItems.push(item);
            }

            objetoPedido['produto'] = listaItems;

            servicosSolicitacaoExterna.create(objetoPedido).then(response => {
                if (response.status === 201) {
                    toast.success(`Solicitação do produto efetuado com sucesso!`, {
                        autoClose: 60000,
                    });
                    localStorage.removeItem('carrinho_producao');

                    if (flagAlteracaoCarrinho) {
                        setFlagAlteracaoCarrinho(false);
                    } else {
                        setFlagAlteracaoCarrinho(true);
                    }
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                } else if (response.status === 400) {
                    toast.warning(response.data.erro, {
                        autoClose: 60000,
                    });
                } else {
                    toast.error(`Solicitação do produto não pode ser efetuada!`, {
                        autoClose: 60000,
                    });

                }
            }).catch(error => {
                console.log(error)
                // toast.error(`${error.response.data.erro || error.response.data.message || 'Não foi possível efetuar o pedido' }`);
                toast.error(`${error.response.data.erro || error.response.data.message || 'Não foi possível efetuar o pedido' }`);

            })
            setShowConfirmacao(false);

        }

        flagAlteracaoCarrinho === true ? setFlagAlteracaoCarrinho(false) : setFlagAlteracaoCarrinho(true);

    }

    const discordo = () => {
        navigate("/SolicitacoesExterna");
    }

    const concordo = () => {
        let aceite = {
            termo: true
        }
        servicosColaborador.aceitarTermo(user.id, aceite ).then(response => {
            if(response.status === 200){
                toast.success('Termos aceito');
                setAceiteTermo(true);
                handleTermo(true);
            }
        }).catch(error => {
            console.log(error);
            toast.error("Não foi possível atualizar o aceite de termos")
        })
    }

    const CarrinhoVazio = () => {
        return <>
            <div className="" style={{ height: '70vh' }}>
                <div className="text-center">
                    <span className="subtitulo" style={{ fontSize: 20 }}>Seu carrinho está vazio, que tal ir até a lista de produtos para adicionar alguns?</span>
                </div>
                <div className="text-center mt-4">
                    <span><a href="/ShoppingProducao" className="btn-icones rounded-3 p-1">Produtos Lev</a></span>
                </div>
            </div>
        </>
    }

    const ModalConfirmacao = () => {
        const handleCheckboxChange = (event) => {
            if (enderecoEnvio) {
                setEnderecoEnvio(false)
            } else {
                setEnderecoEnvio(true)
            }
        };
        return <>

            <Modal className="modal-confirmacao" show={showConfirmacao} onHide={handleCloseConfirmacao}>
                <Modal.Body className="d-flex row bg-lev rounded-5 m-1">
                    <span className="text-light">Você confirma o pedido?</span>
                    <div className="d-flex row">
                        <table>
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td className="text-light">
                                        <strong>Opções de Entrega</strong>
                                    </td>
                                    <td>
                                        <Form.Check
                                            type="checkbox"
                                            label="Retirada Matriz"
                                            className="text-light"
                                            checked={!enderecoEnvio}
                                            onChange={handleCheckboxChange}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Envio Correios"
                                            className="text-light"
                                            checked={enderecoEnvio}
                                            onChange={handleCheckboxChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-light">
                                        <strong>Motivo</strong>
                                    </td>
                                    <td>
                                        <input type="text" className="rounded-3" maxLength={150} required ref={motivo} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-light">
                                        <strong>Nome Parceiro</strong>
                                    </td>
                                    <td>
                                        <input type="text" className="rounded-3" maxLength={150} required ref={nomeParceiro} />
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-light">
                                        <strong>Cód. Parceiro</strong>
                                    </td>
                                    <td>
                                        <input type="text" className="rounded-3 w-25" required ref={parceiro} />
                                    </td>
                                    
                                </tr>
                               

                                {enderecoEnvio && (
                                    <>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Logradouro</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={logradouro} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Número</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={numero} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Bairro</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={bairro} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Complemento</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={complemento} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Cidade</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={cidade} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>Estado</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={estado} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-light">
                                                <strong>CEP</strong>
                                            </td>
                                            <td>
                                                <input type="text" className="rounded-3" ref={cep} />
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button disabled={!aceiteTermo} type="button" className="btn-icones rounded p-1 w-25" onClick={() => solicitarTroca()}>
                        Confirmar
                    </button>
                    <button type="button" className="btn-icones rounded p-1 w-25" onClick={handleCloseConfirmacao}>
                        Voltar
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    }

    const ModalTermo = () => {
        return <>
            <div >
                <Modal show={!aceiteTermo} onHide={handleCloseTermos}>
                    <Modal.Body className="text-center">
                        <Link className="btn-link" to="/Termos" target="_blank">Termos de uso</Link>
                        <p className="mt-3">
                            Ao clicar em "sim", eu, Gerente Comercial da Lev Negócios, declaro que li e estou de acordo com os termos
                        </p>
                    </Modal.Body>
                    <Modal.Footer  >
                        <button type="button" className="border-1 w-25 btn-icones p-1  rounded" onClick={() => concordo()} ><Check color="success" /> <span >Sim</span></button>
                        <button type="button" className="border-1 w-25 btn-icones p-1  rounded" onClick={discordo}><CancelRounded color="error" /><span> Não</span></button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    }

    const ListaProdutos = () => {
        let qtd = carrinho?.produtos !== undefined ? carrinho?.produtos?.length : 0;

        return <>

            {qtd > 0 ? <div className="d-flex  justify-content-center mt-5 mb-5 pb-3">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {carrinho?.produtos?.map((item, index) => {
                            return (
                                <tr key={index} >
                                    <td width={150} >
                                        <img
                                            className="me-3 mb-3 rounded-3"
                                            style={{ width: 100, height: 100 }}
                                            src={`${basePath}/${item.produto.filename}`}
                                            alt={item.produto.filename}
                                        />
                                    </td>
                                    <td width={80}><span className="me-2">{item.produto.Produto[0].nome}</span></td>
                                    <td width={40}><input
                                        className="text-center rounded-3"
                                        style={{ width: 30 }}
                                        max={item.produto.Produto[0].estoque}
                                        value={item.qtd}
                                        onChange={(event) =>
                                            atualizarQuantidade(index, event.target.value)
                                        }
                                    /></td>

                                    <td width={60} className="text-center">
                                        <span className="ms-1">{item.produto.Produto[0].milhas}</span>
                                    </td>

                                    <td>
                                        <span className="ms-1">{item.produto.Produto[0].tamanho}</span>
                                    </td>
                                    <td width={50}><button className="ms-3 btn-icones rounded-2 p-1" onClick={() => removerItem(index)}><Delete /></button></td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div> : <CarrinhoVazio />}
        </>
    }
    return (
        <>
            {!aceiteTermo && <ModalTermo />}
            <ToastContainer />
            <ModalConfirmacao />
            {/* <NavMenu /> */}
            <div className="container">
                <h2 style={{ fontSize: 32 }} className="subtitulo2 text-center">Brindes p/ Parceiros</h2>
                <a style={{ fontSize: 18 }} className="subtitulo" href="/SolicitacoesExterna">Menu anterior</a>
                <div className="d-flex container justify-content-center align-items-center text-center mb-4 mt-4">
                    <div>
                        <div className="subtitulo" style={{ fontSize: 22 }}>Total do pedido: </div>
                        <div style={{ fontSize: 25 }} className="subtitulo2 ms-2">{total} milhas</div>
                    </div>
                    <div>
                        <div className="subtitulo ms-4" style={{ fontSize: 22 }}>Saldo Produção: </div>
                        <div style={{ fontSize: 25 }} className="subtitulo2 ms-2">{pontucaoExterna.pontosAtivos} milhas</div>
                    </div>
                </div>

                <ListaProdutos className="container" />
                {total > 0 && <div className="d-flex justify-content-center align-items-center mt-3">
                    <button disabled={aceiteTermo !== true} onClick={() => setShowConfirmacao(true)} className="text-center btn-icones rounded-2 p-1">Confirmar pedido</button>
                </div>}
            </div>
            <NavMobile />
        </>
    );
};


export default Carrinho;